import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Select, MenuItem, FormControl, InputLabel } from '@mui/material';

interface InviteMemberModalProps {
  open: boolean;
  onClose: () => void;
  onInvite: (email: string, role: string) => void;
}

const InviteMemberModal: React.FC<InviteMemberModalProps> = ({ open, onClose, onInvite }) => {
  const [email, setEmail] = useState<string>('');
  const [role, setRole] = useState<string>('MEMBER'); // Default role

  const handleInvite = () => {
    if (email) {
      onInvite(email, role);
      setEmail('');
      setRole('MEMBER');
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Invite New Team Member</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="email"
          label="Email Address"
          type="email"
          fullWidth
          variant="outlined"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{ mb: 2 }}
        />
        <FormControl fullWidth variant="outlined">
          <InputLabel id="role-select-label">Role</InputLabel>
          <Select
            labelId="role-select-label"
            id="role-select"
            value={role}
            onChange={(e) => setRole(e.target.value as string)}
            label="Role"
          >
            <MenuItem value="OWNER">Owner</MenuItem>
            <MenuItem value="ADMIN">Admin</MenuItem>
            <MenuItem value="MEMBER">Member</MenuItem>
            <MenuItem value="VIEWER">Viewer</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleInvite} variant="contained" color="primary">
          Invite
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InviteMemberModal;
